export default __webpack_public_path__ + "static/media/60.91ba57b9.png";